<h2>Che cos'è il quadro regionale degli standard professionali</h2>
<p>Il Quadro Regionale degli Standard Professionali di Regione Lombardia (QRSP) definisce e
    classifica profili e competenze professionali presenti nella realtà lavorativa lombarda,
    raggruppati in settori economico professionali.</p>

<p>Il Quadro Regionale di standard professionali, costruito secondo regole coerenti con i
    modelli
    europei e nazionali, rappresenta il riferimento univoco per la progettazione e la
    realizzazione
    dei percorsi di formazione continua, permanente e di specializzazione nonchè per la
    certificazione delle competenze acquisite in qualsiasi ambito, che possano avere un
    riconoscimento 'pubblico'.</p>

<p>Il QRSP, quale insieme dei profili professionali esistenti sul territorio e comune
    riferimento
    per i diversi attori territoriali dei sistemi regionali dell'istruzione e formazione
    professionale e del lavoro, è finalizzato a sostenere i processi di progettazione formativa,
    di
    certificazione delle competenze, di lettura dei fabbisogni, di incontro tra domanda e
    offerta,
    di supporto alle transizioni lavorative e formative.</p>

<p>Il QRSP è utile per dare la certezza dei contenuti che la formazione deve trasmettere per
    quel
    determinato profilo professionale. Associata ad ogni competenza ci sono abilità (ciò che la
    persona sa fare) e conoscenze (ciò che la persona sa), che esprimono il 'core' della
    professionalità specifica.</p>

<p>Il QRSP è articolato nelle seguenti sezioni: </p>
<ul>
    <li>Sezione profili professionali e competenze</li>
    <li>Sezione competenze indipendenti</li>
    <li> Sezione competenze di base</li>
    <li>Sezione competenze trasversalie</li>
    <li>Sezione competenze discipline Bionaturali</li>
    <li>Sezione Figure regolamentate/Abilitanti</li>
    <li>Sezione percorsi normati</li>
</ul>

<p>La Direzione Generale IFL ha avviato da mesi - nell'ambito dei lavori della Sottocommissione
    della Commissione Regionale per le Politiche del Lavoro e della Formazione - approfondimenti
    e
    valutazioni finalizzati alla revisione degli standard e dei profili regionali per meglio
    correlarli al Quadro Nazionale di riferimento per il Repertorio Nazionale delle
    qualificazioni
    professionali, di cui al d.lgs. 13/2013.</p>

<p>Conseguentemente, il sistema classificatorio afferisce a 24 Settori Economico Professionali
    previsti dal Quadro di riferimento nazionale delle qualificazioni regionali; i profili
    professionali e le competenze sono stati referenziati al sistema EQF (European Qualification
    Framework) e correlati con la relativa Area di Attività del definendo Repertorio nazionale.
</p>

<p>Il QRSP è il punto di riferimento univoco e imprescindibile per l'organizzazione di percorsi
    di
    formazione continua, permanente e di specializzazione e per la certificazione delle
    competenze.</p>

<p>Pertanto, gli enti di formazione accreditati, che intendano attivare percorsi di formazione
    che
    rilascino un attestato regionale, devono tassativamente ricondurre l'offerta formativa ad
    una o
    più competenze o a profili professionali esplicitati nel QRSP.</p>

<p>E' possibile progettare percorsi formativi che utilizzano competenze all'interno del QRSP sia
    pure 'pescate' da profili diversi, ma il percorso formativo 'aggregato' non può avere una
    denominazione diversa dai profili espressamente inseriti nel QRSP.</p>

<p>La certificazione e il rilascio dell'Attestato non sono previsti nel caso in cui la durata o
    la
    configurazione del percorso non permettano l'acquisizione compiuta di competenze, bensì solo
    di
    alcuni suoi elementi costitutivi; l'unico attestato regionale previsto dalla normativa (LR
    19/2007 e atti attuativi) è l'attestato di competenza.</p>

<p>Eventuali dichiarazioni di partecipazione al percorso, rilasciati dagli enti accreditati, non
    possono riportare il logo regionale. Qualora il percorso formativo sia finanziato attraverso
    una
    politica regionale (per esempio Dote Unica Lavoro o Garanzia Giovani) è necessario citare
    l'iniziativa all'interno della dichiarazione di partecipazione al percorso formativo.</p>
